import { render } from "./adminWrapper.vue?vue&type=template&id=658b3e0e"
import script from "./adminWrapper.vue?vue&type=script&lang=js"
export * from "./adminWrapper.vue?vue&type=script&lang=js"

import exportComponent from "D:\\NET\\AsdCare\\asdcare-internal\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__